<template>
  <div>
    <fieldset>
      <legend>Client information</legend>
      <div class="col-md-9">
        <div class="mb-3">
          <label for="name" class="form-label">Client name*:</label>
          <input
            type="text"
            class="form-control"
            name="name"
            maxlength="40"
            required
            v-model="client.name"
          />
        </div>

        <div class="mb-3">
          <label for="billingcode" class="form-label">Billing code:</label>
          <input
            type="text"
            class="form-control"
            name="billingcode"
            maxlength="40"
            v-model="client.billingcode"
          />
        </div>

        <div class="row mb-3">
          <div class="col-sm-5">
            <div class="form-group">
              <label class="form-label" for="currency">Currency:</label>
              <b-select
                name="currency"
                size="1"
                class="form-select"
                v-model.number="client.currency"
              >
                <option
                  v-for="currency in currencies"
                  :key="currency.id"
                  :value="currency.id"
                >
                  {{ currency.name }}
                </option>
              </b-select>
            </div>
          </div>
          <div class="col-sm-7">
            <div class="form-group">
              <label class="form-label" for="ratio">Ratio *:</label> (Currency /
              Incentiweb points = Ratio)
              <input
                type="text"
                name="ratio"
                size="10"
                class="form-control"
                @click="(e) => check(e)"
                v-model.number="client.ratio"
                required
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-3">
          <label class="form-label" for="company">Welcome to:</label> (If blank,
          will display "Incentiweb")
          <input
            type="text"
            name="company"
            size="40"
            class="form-control"
            v-model="client.company"
          />
        </div>

        <div class="form-group mb-3">
          <label class="form-label" for="taico_phone">Phone:</label> (Where you
          want order inquiries to go)
          <input
            type="text"
            name="taico_phone"
            size="40"
            class="form-control"
            v-model="client.taico_phone"
          />
        </div>
        <div class="form-group mb-3">
          <label class="form-label" for="taico_email">Email address:</label>
          (Where you want order inquiries to go)
          <input
            type="Text"
            name="taico_email"
            size="40"
            class="form-control"
            v-model="client.taico_email"
          />
        </div>
        <div class="form-group mb-3">
          <label class="form-label" for="disclaimer">Disclaimer:</label>
          (Disclaimer for order page, if any)
          <input
            type="Text"
            name="disclaimer"
            size="40"
            class="form-control"
            v-model="client.disclaimer"
          />
        </div>

        <div class="form-group">
          <label class="form-label" for="clientordermessage"
            >Client Order Message:</label
          >
          (Displays after Order)
          <textarea
            name="clientordermessage"
            cols="23"
            rows="5"
            class="form-control"
            v-model="client.clientordermessage"
          ></textarea>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend>Product Index</legend>
      <div class="row">
        <div class="col-md-12">
          <p>
            Category Management Module Notes:
            <br />
            <br />
            To edit a profit margin, double click the field. Only top level
            parent category profit margins can be updated. Each descendant's
            profit margin will be automatically matched to their top level
            parent's margin. Profit margin values must be 0% or greater and less
            than 100%.
            <br />
            <br />
            When &quot;Update&quot; is clicked, the front-end will be refreshed
            with the new exclude and margin values. If you click &quot;Update
            Client Profile&quot; before &quot;Update&quot;, changes in this
            module will be lost.
          </p>
        </div>

        <div class="mb-3 col-md-12">
          <ProductIndexTable />
        </div>

        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="productsonly"
            >Show products only:</label
          >

          <b-form-checkbox
            class="ml-2"
            :false-value="false"
            :true-value="true"
            name="productsonly"
            v-model="client.productsonly"
            switch
          />
        </div>

        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="showcategories"
            >Show categories:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              name="showcategories"
              v-model="client.showcategories"
            />
          
        </div>

        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="showpointranges"
            >Show point ranges:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              name="showpointranges"
              v-model="client.showpointranges"
            />
      
        </div>
        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="showwishlist"
            >Show wish list:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              name="showwishlist"
              v-model="client.showwishlist"
            />
        
        </div>

        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="Isothercntry"
            >Non us country:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              name="Isothercntry"
              v-model="client.Isothercntry"
            />
          
        </div>

        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="form-label" for="productindex_page"
              >Alternate splash page:</label
            >
            <input
              type="text"
              name="productindex_page"
              size="40"
              class="form-control"
              v-model.number="client.productindex_page"
            />
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="form-label" for="categories_featured"
              >Featured categories:</label
            >
            <input
              type="number"
              name="categories_featured"
              class="form-control"
              v-model.number="client.categories_featured"
            />
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
import ProductIndexTable from "./ProductIndexTable.vue";
export default {
  name: "BasicSettings",
  data() {
    return {
      columns: [
        {
          title: "Exclude",
          key: "exclude",
          scopedSlots: { customRender: "exclude" },
          sorter: false,
        },
        {
          title: "Name",
          key: "name",
          dataIndex: "name",
          sorter: true,
        },
        {
          title: "Profit Margin",
          key: "profitmargin",
          dataIndex: "profitmargin",
          sorter: true,
        },
        {
          title: "Notes",
          key: "notes",
          sorter: false,
        },
      ],
    };
  },
  components: {
    ProductIndexTable,
  },
  methods: {
    check(e) {
      const element = e.target;
      element.setAttribute("disabled", "");
      alert(
        "Modification the ratio once orders have been placed is not allowed."
      );
    },
  },
  computed: {
    client() {
      return this.$store.state.manageClients.client;
    },
    currencies() {
      return this.$store.state.manageClients.currencies;
    },
  },
};
</script>
<style scoped>

</style>
